
import { NgProgress } from 'ngx-progressbar';
import { ActivatedRoute, Router, NavigationEnd, Routes } from '@angular/router';
import {
    Component,
    OnInit,
    ViewChild,
    ViewContainerRef,
    OnDestroy,
    Inject,
    ElementRef,
    HostListener 
} from '@angular/core';

import { MarketingService } from '../../services/marketing.service';
import { Promotion } from '../../models/marketing.model';
import { CmsStudioService } from '../../cms/cms-studio.service';
import { CmsViewDirectiveService } from '../../cms/cmsdirectives/cmsviewdirective.service';
import { CmsViewDirectiveComponent } from '../../cms/cmsdirectives/cmsviewdirective.component';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { NgModel } from '@angular/forms';
import { CommonService } from '../../services';
import { NgProgressService } from '../../services/ngProgress.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BreadcrumbComponent } from '../../breadcrumb/breadcrumb.component';
import { Windows11ReportExtractComponent } from './report-extract/windows-11-report-extract.component';
import { Windows11AssessmentService } from '../../services/windows-11-assessment.service';
import { CurrentUserModel } from '../../models/account-ledger.model';
import { AuthService } from '../../services/auth.service';

const LARGETOPWIDTH = "120%";
const UNSETTOPWIDTH = null;
@Component({
    selector: 'app-windows-11-report',
    templateUrl: './windows-11-report.component.html',
    styleUrls: ['./windows-11-report.component.css'],
})
export class Windows11ReportComponent implements OnInit, OnDestroy {
    @ViewChild("ParentWrapper", { static: false }) parentWrapper: ElementRef;

    created = false;
    loadContent = false;
    columnData: string[] = [];
    @ViewChild('entry', { read: ViewContainerRef }) entry: ViewContainerRef;
    @ViewChild('brandSelect') private brandSelect: NgModel;

    windowsReadeadinessActiveRouter: Subscription;
    windowsReadeadinessActiveRouterParent: Subscription;
    windowsReadeadinessRouterParaChange: Subscription;

    isLoading = true;
    breadcrumbRef: any;

    toplevelWidth = LARGETOPWIDTH;
  
    laodingCongratulation = false;
    allDevicesUpgradedToWin11: boolean = false;

    currentUserModel: CurrentUserModel;
    isAU: boolean;
    constructor(
        private activeRouter: ActivatedRoute,
        private marketingService: MarketingService,
        public ngProgress: NgProgressService,
        private router: Router,
        private windows11AssessmentService: Windows11AssessmentService,
        private authService: AuthService,
        @Inject(CmsViewDirectiveService) private service,
        @Inject(ViewContainerRef) private viewContainerRef
    ) {
        this.toplevelWidth = this.router.url.includes("windows-11-report") ? LARGETOPWIDTH : UNSETTOPWIDTH;
    }

    @HostListener('window:beforeunload', ['$event'])
    onBeforeUnload(event: BeforeUnloadEvent) {
        sessionStorage.setItem('refresh-flag', 'true');
    }

    ngOnInit() {
        

        this.ngProgress.start();
        this.windowsReadeadinessRouterParaChange = this.activeRouter.paramMap.subscribe(param => {
            $('.child-loader').animate({ scrollLeft: $('#win-11-report').width() }, 100);
            this.loadContent = false;
            this.windowsReadeadinessActiveRouter = this.activeRouter.url.subscribe(value => {
            },
            (error: any) => {
                console.error(error);
                this.ngProgress.done();
            });
            this.windows11AssessmentService.allDevicesUpgradedToWin11$.subscribe(value => {
                this.allDevicesUpgradedToWin11 = value;
                (this.allDevicesUpgradedToWin11) ? this.laodingCongratulation = true : this.laodingCongratulation = false;
              });
        });

        const isRefreshed = sessionStorage.getItem('refresh-flag');
        if (isRefreshed) {
            sessionStorage.removeItem('refresh-flag');
            this.router.navigate(['/windows-11-readiness']); // Navigate to root
            this.ngProgress.done();
        }

        this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
            this.currentUserModel = res;
            this.isAU = this.currentUserModel.isAU;
            console.log("isAU", this.isAU);
          },
          (error: any) => {
              console.info(error);
          });
    }
    ngUnsubscribe(ngUnsubscribe: any): import("rxjs").OperatorFunction<NavigationEnd, NavigationEnd> {
        throw new Error('Method not implemented.');
    }

    navigateToReportExtract(){
        this.router.navigate(['/windows-11-readiness/windows-11-report/windows-11-report-extract']);
    }

    ngOnDestroy(): void {
        // this.closesub$.unsubscribe();
    }

    close() {
        this.router.navigateByUrl('/windows-11-readiness');
        //window.location.reload();
    }


    onLoading(currentLoadingStatus: boolean) {
        this.ngProgress.done();
        console.log("currentLoadingStatus", currentLoadingStatus);
        this.loadContent = !currentLoadingStatus;
        console.log("loadContent", this.loadContent);
    }
    onNavigate(id, url) {
        window.open(url, '_blank');
    }
}